import DesktopWidgetRevenue from './DesktopWidgetRevenue';
import MobileWidgetRevenue from './mobileWidgetRevenue/MobileWidgetRevenue';
import useFormat from '../../../../hooks/useFormat';
import { WidgetComponentProps } from '../../../../types/widget';

const WidgetRevenue = ({ configuration, readOnly }: WidgetComponentProps) => {
	const { isMobileFormat } = useFormat();

	return isMobileFormat ? (
		<MobileWidgetRevenue configuration={configuration} />
	) : (
		<DesktopWidgetRevenue configuration={configuration} readOnly={readOnly} />
	);
};

export default WidgetRevenue;
